<template>
  <v-app-bar
    app
    fixed
    height="70px"
    clipped-left
    v-if="currentUser"
    class="c-header-toolbar"
  >
    <v-app-bar-nav-icon @click.stop="switchMiniVariant">
      <v-icon>menu</v-icon>
    </v-app-bar-nav-icon>

    <v-toolbar-title
      class="hidden-xs-only"
    >
      <v-layout justify-start align-center>
        <header-component-client-info/>

        <header-advertisers-selector/>
      </v-layout>

    </v-toolbar-title>

    <v-spacer/>

    <header-component-sync/>

    <!-- <header-component-notifications/> -->

    <header-component-user-info/>

  </v-app-bar>
</template>

<script>
  import HeaderComponentClientInfo from './HeaderComponentClientInfo.vue'
  import HeaderComponentSync from './HeaderComponentSync.vue'
  import HeaderComponentNotifications from './HeaderComponentNotifications.vue'
  import HeaderComponentUserInfo from './HeaderComponentUserInfo.vue'
  import HeaderAdvertisersSelector from './HeaderAdvertisersSelector'

  export default {
    name: 'header-component',
    components: {
      HeaderAdvertisersSelector,
      HeaderComponentClientInfo,
      HeaderComponentSync,
      HeaderComponentNotifications,
      HeaderComponentUserInfo
    },
    data () {
      return {
        clipped: true,
        drawer: true,
        fixed: false
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.getCurrentUser
      }
    },
    methods: {
      switchMiniVariant () {
        this.$emit('switchMiniVariant')
      }
    }
  }
</script>
<style lang="scss">
  $background-color: rgb(236, 243, 247);
  .c-header-toolbar {
    background: $background-color!important;
    z-index: 999 !important;
  }
</style>
